import styled from 'styled-components';
import { Button, ButtonGroup, ModalFooter as VHSModalFooter } from '@wistia/vhs';
import { trackStructEvent } from '~/utilities/snowplow';
import type { CSSProperties, JSX } from 'react';
import { isNotNil } from '~/utilities/type-guards';
import type { IconNameType } from '@wistia/vhs';

export const StyledModalFooter = styled(VHSModalFooter)`
  padding: ${({ theme }) => theme.spacing.space06};
  padding-top: 0;
  width: 100%;
`;

export type ModalFooterProps = {
  /**
   * Label for the CTA button
   */
  ctaLabel: string;
  /**
   * When the CTA button is clicked, this function will be called
   */
  onClickCta: () => void;
  /**
   * Label for the cancel button
   */
  cancelLabel?: string;
  /**
   * When the cancel button is clicked, this function will be called
   */
  onClickCancel?: () => void;
  /**
   * Name of the icon to display
   */
  iconName?: IconNameType;
  /**
   * Position of the icon
   */
  iconPosition?: 'end' | 'start';

  style?: CSSProperties;
};

export const ModalFooter = ({
  ctaLabel,
  onClickCta,
  cancelLabel,
  onClickCancel,
  iconName,
  iconPosition,
  style = {},
}: ModalFooterProps): JSX.Element => (
  <StyledModalFooter style={style}>
    <ButtonGroup align="right">
      {cancelLabel != null && isNotNil(onClickCancel) && (
        <Button
          label={cancelLabel}
          onClick={() => {
            onClickCancel();

            trackStructEvent({
              action: 'click',
              category: 'button',
              label: 'integrations-funnel-modal-dismissed',
            });
          }}
          variant="secondary"
        />
      )}
      <Button
        label={ctaLabel}
        onClick={onClickCta}
        iconName={iconName}
        iconPosition={iconPosition}
      />
    </ButtonGroup>
  </StyledModalFooter>
);
